export const storeDisabledMarkerSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none">
  <g filter="url(#a)">
    <path fill="#fff" fill-rule="evenodd" d="M14 24a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z" clip-rule="evenodd"/>
  </g>
  <g filter="url(#b)">
    <path fill="#000" fill-opacity=".5" fill-rule="evenodd" d="M14 21a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z" clip-rule="evenodd"/>
  </g>
  <defs>
    <filter id="a" width="28" height="28" x="0" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="2"/>
      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
      <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_6014_7555"/>
      <feBlend in="SourceGraphic" in2="effect1_dropShadow_6014_7555" result="shape"/>
    </filter>
    <filter id="b" width="22" height="22" x="3" y="3" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="2"/>
      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
      <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_6014_7555"/>
      <feBlend in="SourceGraphic" in2="effect1_dropShadow_6014_7555" result="shape"/>
    </filter>
  </defs>
</svg>
`;

export const storeDisabledMarkerSvgRevamp = `
<svg xmlns="http://www.w3.org/2000/svg" width="37" height="36" fill="none">
  <path fill="#999" d="M18.5 2.44a10.88 10.88 0 0 0-10.89 10.9c0 8.16 10.89 20.22 10.89 20.22S29.39 21.5 29.39 13.33c0-6.02-4.87-10.89-10.89-10.89"/>
</svg>
`;

// eslint-disable-next-line import/no-default-export
export default storeDisabledMarkerSvg;
